import { _ } from "libs";

import React, { useEffect, useState } from "react";
import withRedux from "../../withRedux";
import { User } from "../../types";
import { loadFriends } from "../../actions";
import UsersList from "../usersLists";
import PlayerSidebar from "../playerSidebar";
import FriendRequestsList from "../friendRequestsList";
import Loader from "../loader";
import friendSelector from "../../selectors/friendSelector";
import { InvisibleInfiniteLoader } from "../infiniteLoader";

const BuddiesPage = ({ loadFriends, friends }: { loadFriends: any; friends: User[] }) => {
	const [loading, setLoading] = useState(false);
	const [selectedUser, selectUser] = useState(null as User);
	const [currentPage, setPage] = useState(1);
	const [hasMoreResults, setHasMoreResults] = useState(true);
	const [loadedFriends, setFriends] = useState(friends);

	useEffect(() => {
		reloadFriends(currentPage);
	}, [currentPage]);

	const reloadFriends = page => {
		loadFriends({
			pageCurrent: page,
			forceLoading: true,
		}).then(data => {
			if (!data) {
				return;
			}
			setFriends([...loadedFriends, ...data]);
			setLoading(false);
			if (data.length === 0) {
				setHasMoreResults(false);
			}
		});
	};

	const closePlayerSidebar = () => {
		selectUser(null);
	};

	const onViewChange = async (inView: boolean, observerEntry) => {
		const shouldLoad = inView && hasMoreResults && !loading;

		if (shouldLoad) {
			setPage(currentPage + 1);
		}
	};

	return (
		<div className="contentWrapper buddyPlayersPage">
			<div className="contentLeft">
				<div className="playersBody">
					{loading ? (
						<Loader />
					) : loadedFriends && loadedFriends.length > 0 ? (
						<UsersList users={loadedFriends} onSelect={selectUser} selectedUser={selectedUser} />
					) : (
						<div className="noResults">
							<h5>{_("players.buddies.noResults.heading")}</h5>
							<p>{_("players.buddies.noResults.description")}</p>
						</div>
					)}
					<InvisibleInfiniteLoader onViewChange={onViewChange} />
					{loading ? <Loader /> : null}
				</div>
			</div>
			<div className="contentRight">
				{selectedUser ? (
					<PlayerSidebar user={selectedUser} onClose={closePlayerSidebar} />
				) : (
					<FriendRequestsList />
				)}
			</div>
		</div>
	);
};

const mapStateToProps = ({ social: { friends } }, ownProps) => {
	friends = friendSelector(friends);
	return { friends };
};

export default withRedux({ loadFriends }, mapStateToProps)(BuddiesPage);
